import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FilterContainer } from 'components/filter/filters-next/FilterContainer';
import { FilterListItem } from 'components/filter/filters-next/FilterListItem';
import {
    ContentFilterComponent,
    FilterIcon,
    LabelFilterComponent,
    ServerKey,
} from 'components/filter/types';

export const filterKey: ServerKey = 'contactAddress';
export const Label: LabelFilterComponent = () => 'Address';

export const Icon: FilterIcon = faLocationDot;

export const Filter: ContentFilterComponent = () => {
    return (
        <FilterContainer className={'!p-1.5'}>
            <FilterListItem serverKey={'addressCity'} />
            <FilterListItem serverKey={'addressState'} />
            <FilterListItem serverKey={'addressZip'} />
            <FilterListItem serverKey={'hasPrimaryAddress'} />
        </FilterContainer>
    );
};
